import { useState } from "react";
import { Skeleton } from "@/components/atoms";
import { PrivateNetworkModals } from "@/components/organisms/PrivateNetwork/PrivateNetworkModals";
import { useGetNetworkParams } from "@/components/organisms/PrivateNetwork/hooks/useGetNetworkParams";
import { ReceivedInvitationsBannerList } from "@/components/organisms/PrivateNetwork/ReceivedInvitationsBannerList";
import { PrivateNetworkTable } from "@/components/organisms/PrivateNetwork/tables/PrivateNetworkTable";
import { PRIVATE_NETWORK_DEFAULT_SORT } from "@/components/organisms/PrivateNetwork/helpers";
import { PrivateNetworkStep } from "@/components/organisms/PrivateNetwork/types";
import { useGetNetworkQuery, useGetReceivedInvitationsQuery } from "@/redux/apis/network/networkApi";
import { useAppSelector } from "@/redux/hooks";
import { networkSelector } from "@/redux/slices/network/selectors";
import { NetworkItem } from "@/redux/slices/network/types";

export const PrivateNetworkActive = () => {
  const { params } = useGetNetworkParams(["active", "pending-sent"], PRIVATE_NETWORK_DEFAULT_SORT);
  const { isLoading: isTableLoading } = useGetNetworkQuery(params, { refetchOnMountOrArgChange: true });
  const { data: receivedData, isLoading: isReceivedLoading } = useGetReceivedInvitationsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const items = useAppSelector(networkSelector);
  const receivedItems = receivedData?.data.items ?? [];

  const [pendingDisconnectRelationship, setPendingDisconnectRelationship] = useState<NetworkItem>();
  const [pendingUpdateTier, setPendingUpdateTier] = useState<NetworkItem>();
  const [step, setStep] = useState<PrivateNetworkStep>(undefined);

  const isLoading = isTableLoading && isReceivedLoading;

  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="mt-2">
          <ReceivedInvitationsBannerList items={receivedItems} />
          <PrivateNetworkTable
            items={items}
            setPendingDisconnectRelationship={setPendingDisconnectRelationship}
            setPendingUpdateTier={setPendingUpdateTier}
            setStep={setStep}
            defaultSort={PRIVATE_NETWORK_DEFAULT_SORT}
          />
          <PrivateNetworkTable.Pagination />
        </div>
      )}
      <PrivateNetworkModals
        step={step}
        setStep={setStep}
        setPendingDisconnectRelationship={setPendingDisconnectRelationship}
        pendingDisconnectRelationship={pendingDisconnectRelationship}
        pendingUpdateTier={pendingUpdateTier}
        setPendingUpdateTier={setPendingUpdateTier}
      />
    </>
  );
};
